// Currency + numeric helpers
export const fmt$ = (n, decimals = 0) => {
  if (n == null || isNaN(n)) return "—";
  return new Intl.NumberFormat("en-US", {
    style: "currency", currency: "USD",
    minimumFractionDigits: decimals, maximumFractionDigits: decimals,
  }).format(n);
};
export const fmtPct = (n, decimals = 1) => (n == null || isNaN(n) ? "—" : `${Number(n).toFixed(decimals)}%`);
export const num = (v) => (v === "" || v == null ? 0 : Number(v) || 0);
